
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signIn } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    console.log('🔐 Intentando login con:', email);

    const { data, error } = await signIn(email, password);

    console.log('📊 Resultado login:', { data, error });

    if (error) {
      console.error('❌ Error completo:', error);
      setError(`Error: ${error.message || 'Email o contraseña incorrectos'}`);
      setLoading(false);
    } else {
      console.log('✅ Login exitoso');
      navigate('/mi-espacio');
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F7F4] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <Link to="/" className="flex justify-center mb-8">
          <img
            src="https://static.readdy.ai/image/e4930f1328430401d33e8e8f8ac29155/b01860838619946e39474997d6f77be0.jpeg"
            alt="Una voz más que propia"
            className="h-16 w-auto"
          />
        </Link>

        {/* Card */}
        <div className="bg-white rounded-2xl shadow-xl p-8 border border-[#E8E4E0]">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-serif text-gray-800 mb-2">Bienvenida de vuelta</h1>
            <p className="text-gray-500 text-sm">Accede a tu espacio personal</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            {error && (
              <div className="bg-red-50 text-red-600 text-sm p-3 rounded-lg flex items-center gap-2">
                <i className="ri-error-warning-line"></i>
                {error}
              </div>
            )}

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">
                Email
              </label>
              <div className="relative">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line"></i>
                </span>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#BEA6BE]/50 focus:border-[#BEA6BE] transition-all"
                  placeholder="tu@email.com"
                  required
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">
                Contraseña
              </label>
              <div className="relative">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5 flex items-center justify-center">
                  <i className="ri-lock-line"></i>
                </span>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#BEA6BE]/50 focus:border-[#BEA6BE] transition-all"
                  placeholder="••••••••"
                  required
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3.5 bg-[#BEA6BE] text-white rounded-lg font-medium hover:bg-[#A89BA8] transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap flex items-center justify-center gap-2"
            >
              {loading ? (
                <>
                  <i className="ri-loader-4-line animate-spin"></i>
                  Entrando...
                </>
              ) : (
                'Entrar a mi espacio'
              )}
            </button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-sm text-gray-500">
              ¿Aún no tienes cuenta?{' '}
              <Link to="/auth/registro" className="text-[#BEA6BE] font-medium hover:underline">
                Regístrate aquí
              </Link>
            </p>
          </div>
        </div>

        {/* Back to home */}
        <div className="mt-6 text-center">
          <Link to="/" className="text-sm text-gray-500 hover:text-[#BEA6BE] transition-colors inline-flex items-center gap-1">
            <i className="ri-arrow-left-line"></i>
            Volver al inicio
          </Link>
        </div>
      </div>
    </div>
  );
}
